module.exports = __webpack_public_path__ + "img/utility_stopped.74b2eea5.svg";